/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/**
 * 验证流程异步加载组件配置
 * 统一管理各个验证步骤的组件异步导入
 */

/** 异步加载联系人信息组件 */
export const ExpContacts = () => import(
  /* webpackChunkName: "exp-contacts" */ './components/verify-stages/exp-contacts'
) as any;

export const Contacts = () => import(
  /* webpackChunkName: "contacts" */ './components/verify-stages/contacts'
) as any;

/** 异步加载个人资料组件 */
export const ExpProfile = () => import(
  /* webpackChunkName: "profile" */ './components/verify-stages/exp-profile'
) as any;

export const Profile = () => import(
  /* webpackChunkName: "profile" */ './components/verify-stages/profile'
) as any;

export const TwoFactor = () => import(
  /* webpackChunkName: "two-factor" */ './components/verify-stages/two-factor/index.vue'
) as any;

/** header通知栏组件(1. ocr身份证过期提醒) */
export const HeaderNotice = () => import(
  /* webpackChunkName: "header-notice" */ '@/views_v2/verify-credit/components/header-notice'
) as any;
